import { buildings, gems } from './entities';
import { rig } from './scene';
import { BB } from './state';
import { $ } from './util';

export const mapC = $('#mapc'), mapG = mapC.getContext('2d'); export const mapLayer = document.createElement('canvas'); mapLayer.width = mapLayer.height = 320; export const mapLG = mapLayer.getContext('2d');
export const minimap = { dirty: true };
export function mapXY(x, z){ const s = 320/(2*BB.half+200); return [160 + x*s, 160 + z*s]; }
export function drawMap(){
  if (minimap.dirty){ minimap.dirty = false; mapLG.clearRect(0,0,320,320);
    const s = 320/(2*BB.half+200);
    for (const gm of gems){ const [x,y] = mapXY(gm.g.position.x, gm.g.position.z); mapLG.fillStyle = '#f5b642'; mapLG.beginPath(); mapLG.arc(x,y,3.5,0,7); mapLG.fill(); }
    for (const b of buildings){ const u = b.userData; const [x,y] = mapXY(u.center.x, u.center.z); mapLG.fillStyle = u.beacon ? '#f5b642' : (u.h > 60 ? 'rgba(242,233,214,.75)' : 'rgba(242,233,214,.35)'); mapLG.fillRect(x-u.size.x*s/2, y-u.size.z*s/2, Math.max(2,u.size.x*s), Math.max(2,u.size.z*s)); }
  }
  mapG.clearRect(0,0,320,320); mapG.drawImage(mapLayer,0,0);
  const [px,py] = mapXY(rig.base.x, rig.base.z);
  mapG.save(); mapG.translate(px,py); mapG.rotate(-rig.yaw);
  mapG.fillStyle = 'rgba(255,59,47,.18)'; mapG.beginPath(); mapG.moveTo(0,0); mapG.lineTo(-40,-70); mapG.lineTo(40,-70); mapG.closePath(); mapG.fill();
  mapG.fillStyle = '#ff3b2f'; mapG.beginPath(); mapG.moveTo(0,-9); mapG.lineTo(6,6); mapG.lineTo(-6,6); mapG.closePath(); mapG.fill();
  mapG.restore();
}

